const $ = jQuery.noConflict();

function toggleAlertBar() {

	if ($('.header-alert').length) {
		let hideAlertBar = document.cookie.match(new RegExp( "(?:^|; )" + 'hideAlertBar'.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)" ));
		hideAlertBar = hideAlertBar ? decodeURIComponent(hideAlertBar[1]) : 'nope';
		if ( hideAlertBar == 'active') {
			$('.header-alert').removeClass('show-alert');
		}
		$('.header-alert--close').on('click', function() {
			$('.header-alert').removeClass('show-alert');
			let dateExpires = new Date(Date.now() + 86400e3);
			dateExpires = dateExpires.toUTCString();
			document.cookie = "hideAlertBar=active; path=/; expires=" + dateExpires;
		});
	}

}
export default toggleAlertBar;